﻿import controller from "./controller";

export function accessibleSelect(context) {
  const singleSelect = context;
  const formId = singleSelect.closest("form")?.id || "";
  const storageKey = singleSelect.name
    ? "epiForm_" + formId + "_" + singleSelect.name
    : null;
  const selectElements = {
    nativeSelect: null,
    customSelect: null,
    customTrigger: null,
    customOptionsWrapper: null,
    customOptions: [],
    customOptionsCount: 0,
    optionChecked: "",
    optionHoveredIndex: -1,
  };
  function init() {
    singleSelect.classList.add("native-select");

    const selectParent = singleSelect.parentNode;
    const selectWrapper = document.createElement("DIV");

    selectWrapper.classList.add("select-wrapper");

    if (singleSelect.classList.contains("white"))
      selectWrapper.classList.add("select-wrapper--white");

    selectWrapper.appendChild(singleSelect);
    selectElements.nativeSelect = singleSelect;

    //Custom select wrapper
    const customWrapper = document.createElement("DIV");
    customWrapper.classList.add("custom-select");
    customWrapper.setAttribute("aria-hidden", "true");

    //Trigger
    const customTrigger = document.createElement("DIV");
    customTrigger.classList.add(
      "custom-select__trigger",
      "custom-select__trigger--init",
    );
    customTrigger.innerHTML = singleSelect.options[0].innerHTML;
    customWrapper.appendChild(customTrigger);
    selectElements.customTrigger = customTrigger;

    //Options wrapper
    const customOptionsWrapper = document.createElement("DIV");
    customOptionsWrapper.classList.add("custom-select__options");
    customWrapper.appendChild(customOptionsWrapper);
    selectElements.customOptionsWrapper = customOptionsWrapper;

    // Restore a previously saved selection (survives page refresh).
    if (storageKey) {
      const resetKey = storageKey.replace(/^epiForm_/, "epiFormReset_");
      if (sessionStorage.getItem(resetKey)) {
        // Reset flag takes priority over any saved value; clear both so required validation fires.
        sessionStorage.removeItem(resetKey);
        sessionStorage.removeItem(storageKey);
        singleSelect.value = "";
      } else {
        const saved = sessionStorage.getItem(storageKey);
        if (saved) {
          singleSelect.value = saved;
        } else if (singleSelect.options[0] && singleSelect.options[0].disabled) {
          // No saved value: clear stale server-pre-filled data.
          singleSelect.value = "";
        }
      }
    }

    //Options
    addOptionsToWrapper(customOptionsWrapper, singleSelect);

    //Append all items
    selectWrapper.appendChild(customWrapper);
    selectParent.appendChild(selectWrapper);
    selectElements.customSelect = selectWrapper;

    addEventHandlersToSelect();
  }

  const addOptionsToWrapper = function (wrapper, singleSelect) {
    for (var i = 0; i < singleSelect.length; i++) {
      if (!singleSelect.options[i].disabled) {
        const singleOption = document.createElement("DIV");

        singleOption.classList.add("custom-select__option");
        singleOption.innerHTML = singleSelect.options[i].innerText;
        singleOption.setAttribute(
          "data-value",
          singleSelect.options[i].attributes.value.value ||
            singleSelect.options[i].attributes.value,
        );

        if (singleSelect.options[i].selected) {
          singleOption.classList.add("isActive");
          selectElements.customTrigger.textContent =
            singleSelect.options[i].innerText;

          if (
            selectElements.customTrigger.classList.contains(
              "custom-select__trigger--init",
            )
          )
            selectElements.customTrigger.classList.remove(
              "custom-select__trigger--init",
            );
        }

        wrapper.appendChild(singleOption);
        selectElements.customOptions.push(singleOption);
        selectElements.customOptionsCount = selectElements.customOptionsCount++;
      }
    }
  };

  const addEventHandlersToSelect = function () {
    // Toggle custom select visibility when clicking the box
    selectElements.customTrigger.addEventListener("click", (e) => {
      const isClosed =
        !selectElements.customSelect.classList.contains("isActive");

      if (isClosed) openSelectCustom();
      else closeSelectCustom();
    });

    // Update selectCustom value when selectNative is changed.
    selectElements.nativeSelect.addEventListener("change", (e) => {
      const value = e.target.value;
      if (storageKey) {
        if (value) sessionStorage.setItem(storageKey, value);
        else sessionStorage.removeItem(storageKey);
        // Explicit selection clears the reset flag so it doesn't interfere on next load.
        sessionStorage.removeItem(storageKey.replace(/^epiForm_/, "epiFormReset_"));
      }
      const elRespectiveCustomOption =
        selectElements.customOptionsWrapper.querySelectorAll(
          `[data-value="${value}"]`,
        )[0];
      if (elRespectiveCustomOption)
        updateCustomSelectChecked(value, elRespectiveCustomOption.textContent);
    });

    // Sync custom UI when the parent form is reset
    const parentForm = selectElements.nativeSelect.closest("form");
    if (parentForm) {
      const resetCustomUi = () => {
        selectElements.nativeSelect.value = "";
        selectElements.customOptions.forEach((opt) =>
          opt.classList.remove("isActive"),
        );
        selectElements.optionChecked = "";
        selectElements.customTrigger.textContent =
          selectElements.nativeSelect.options[0].textContent;
        selectElements.customTrigger.classList.add(
          "custom-select__trigger--init",
        );
      };

      parentForm.addEventListener("reset", () => {
        if (storageKey) {
          sessionStorage.removeItem(storageKey);
          // Different prefix: survives clearFormSession and the page reload.
          sessionStorage.setItem(storageKey.replace(/^epiForm_/, "epiFormReset_"), "1");
        }
        resetCustomUi();
        // EPiServer restores the native select after our handler; re-apply once all synchronous handlers finish.
        setTimeout(resetCustomUi, 0);
      });

      // Capture phase: force empty before EPiServer's click handler reads the form for its AJAX call.
      parentForm.addEventListener("click", (e) => {
        if (!e.target.closest(".btnNext")) return;
        const resetKey = storageKey
          ? storageKey.replace(/^epiForm_/, "epiFormReset_")
          : null;
        if (resetKey && sessionStorage.getItem(resetKey)) {
          selectElements.nativeSelect.value = "";
        }
      }, true);
    }

    // Update selectCustom value when an option is clicked or hovered
    selectElements.customOptions.forEach(function (elOption, index) {
      elOption.addEventListener("click", (e) => {
        const value = e.target.getAttribute("data-value");

        // Sync native select to have the same value
        selectElements.nativeSelect.value = value;

        //Trigger native select change
        var event = new Event("change");
        selectElements.nativeSelect.dispatchEvent(event);

        updateCustomSelectChecked(value, e.target.textContent);
        closeSelectCustom();
      });

      elOption.addEventListener("mouseenter", (e) => {
        updateCustomSelectHovered(index);
      });

      // TODO: Toggle these event listeners based on selectCustom visibility
    });
  };

  function openSelectCustom() {
    selectElements.customSelect.classList.add("isActive");
    // Remove aria-hidden in case this was opened by a user
    // who uses AT (e.g. Screen Reader) and a mouse at the same time.
    selectElements.customSelect.setAttribute("aria-hidden", false);

    if (selectElements.optionChecked) {
      const optionCheckedIndex = selectElements.customOptions.findIndex(
        (el) => el.getAttribute("data-value") === selectElements.optionChecked,
      );
      updateCustomSelectHovered(optionCheckedIndex);
    }

    // Add related event listeners
    document.addEventListener("click", watchClickOutside);
    document.addEventListener("keydown", supportKeyboardNavigation);
  }

  function closeSelectCustom() {
    selectElements.customSelect.classList.remove("isActive");
    selectElements.customSelect.setAttribute("aria-hidden", true);
    updateCustomSelectHovered(-1);

    // Remove related event listeners
    document.removeEventListener("click", watchClickOutside);
    document.removeEventListener("keydown", supportKeyboardNavigation);
  }

  function updateCustomSelectHovered(newIndex) {
    const prevOption =
      selectElements.customOptionsWrapper.children[
        selectElements.optionHoveredIndex
      ];
    const option = selectElements.customOptionsWrapper.children[newIndex];

    if (prevOption) prevOption.classList.remove("isHover");

    if (option) option.classList.add("isHover");

    selectElements.optionHoveredIndex = newIndex;
  }

  function updateCustomSelectChecked(value, text) {
    const prevValue = selectElements.optionChecked;
    const elPrevOption = selectElements.customOptionsWrapper.querySelector(
      `[data-value="${prevValue}"`,
    );
    const elOption = selectElements.customOptionsWrapper.querySelector(
      `[data-value="${value}"`,
    );

    if (elPrevOption) elPrevOption.classList.remove("isActive");

    if (elOption) elOption.classList.add("isActive");

    selectElements.customTrigger.textContent = text;
    selectElements.optionChecked = value;

    if (
      selectElements.customTrigger.classList.contains(
        "custom-select__trigger--init",
      )
    )
      selectElements.customTrigger.classList.remove(
        "custom-select__trigger--init",
      );
  }

  function watchClickOutside(e) {
    const didClickedOutside = !selectElements.customSelect.contains(
      event.target,
    );

    if (didClickedOutside) closeSelectCustom();
  }

  function supportKeyboardNavigation(e) {
    // press down -> go next
    if (
      e.keyCode === 40 &&
      selectElements.optionHoveredIndex < selectElements.customOptionsCount - 1
    ) {
      let index = selectElements.optionHoveredIndex;
      e.preventDefault(); // prevent page scrolling
      updateCustomSelectHovered(selectElements.optionHoveredIndex + 1);
    }

    // press up -> go previous
    if (e.keyCode === 38 && selectElements.optionHoveredIndex > 0) {
      e.preventDefault(); // prevent page scrolling
      updateCustomSelectHovered(selectElements.optionHoveredIndex - 1);
    }

    // press Enter or space -> select the option
    if (e.keyCode === 13 || event.keyCode === 32) {
      e.preventDefault();

      const option =
        selectElements.customOptionsWrapper.children[
          selectElements.optionHoveredIndex
        ];
      const value = option && option.getAttribute("data-value");

      if (value) {
        selectElements.nativeSelect.value = value;
        updateCustomSelectChecked(value, option.textContent);
      }

      closeSelectCustom();
    }

    // press ESC -> close selectCustom
    if (event.keyCode === 27) closeSelectCustom();
  }

  const contextName = context.getAttribute("name");

  if (contextName && contextName === "terminate") init();
  else return { init };
}

controller.add("accessible-select", accessibleSelect);
